import { Injectable } from '@angular/core';
import { EnvironmentService } from '../environment-service/environment.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BuildHealthService {

  constructor(
    private http: HttpClient, 
    private environmentService: EnvironmentService
  ) { }

  getBuilds(numberOfBuilds: number, beginDate: Date, endDate: Date) {
    const url = this.environmentService.getApiRoot() + 'vsts/builds/health';

    const body = {
      numberOfBuilds: numberOfBuilds,
      isoBeginDate: beginDate.toISOString(),
      isoEndDate: endDate.toISOString()
    };

    return this.http.post(url, body);
      //.pipe(catchError(this.handleError<any>('getting build health')));
  }

//   private handleError<T> (operation: string, result?: T) {
//     return (error: any): Observable<T> => {

//       const notification = [
//         {error: `There was an error ${operation}.`},
//         {error: 'Most likely vsts:monitoringPAT in web.config is expired or invalid.'}
//       ];

//       this.notificationService.showError(notification);
   
//       // TODO: better job of transforming error for user consumption
//       console.warn(`${operation} failed: ${error || error.message}`);
   
//       // Let the app keep running by returning an empty result.
//       return of(result as T);
//     };
//   }
}
